export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const fetchReadings = async () => {
  const response = await fetch(`${API_BASE_URL}/api/readings`);
  const data = await response.json();
  return data;
};

export const fetchBookInfo = async (bookKey) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/info`);
  if (!response.ok) {
    throw new Error("Failed to fetch book info");
  }
  return response.json();
};

export const fetchBookSections = async (bookKey) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/sections`);
  if (!response.ok) {
    throw new Error("Failed to fetch book sections");
  }
  return response.json();
};

export const fetchBookSection = async (bookKey, sectionId) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/section/${sectionId}`);
  if (!response.ok) {
    throw new Error("Failed to fetch book section");
  }
  const html = await response.text();

  // Create a temporary DOM element to parse and modify the HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  // Transform all image sources
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    if (src && !src.startsWith("http")) {
      img.src = `${API_BASE_URL}${src}`;
    }
  });
  doc.querySelectorAll("image").forEach((img) => {
    const src = img.getAttribute("xlink:href");
    if (src && !src.startsWith("http")) {
      img.setAttribute("xlink:href", `${API_BASE_URL}${src}`);
    }
  });

  return doc.body.innerHTML;
};

export const fetchNotes = async (readingKey) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${readingKey}/notes`);
  const data = await response.json();
  return data;
};

export const saveNote = async (readingKey, note) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${readingKey}/notes`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(note),
  });
  return response.json();
};

export const deleteNote = async (readingKey, noteId) => {
  const response = await fetch(
    `${API_BASE_URL}/api/book/${readingKey}/notes/${noteId}`,
    {
      method: "DELETE",
    }
  );
  return response.json();
};

export const fetchBookEntities = async (bookKey) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/entities`);
  if (!response.ok) {
    throw new Error("Failed to fetch book entities");
  }
  return response.json();
};

export const saveEntity = async (readingKey, entity) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${readingKey}/entities`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(entity),
  });
  return response.json();
};

export const fetchBookSummary = async (bookKey) => {
  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/summary`);
  if (!response.ok) {
    if (response.status === 404) {
      return null;
    }
    throw new Error("Failed to fetch book summary");
  }

  const data = await response.json();
  return data.summary;
};

export const fetchBookSummarySource = async (bookKey, { startLine, endLine, sourceFile = "book.md" }) => {
  const params = new URLSearchParams({
    start_line: String(startLine),
    end_line: String(endLine),
    source_file: sourceFile,
  });

  const response = await fetch(`${API_BASE_URL}/api/book/${bookKey}/summary/source?${params.toString()}`);
  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(errorBody.detail || "Failed to fetch summary source excerpt");
  }

  return response.json();
};

export const convertEpubToMarkdown = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE_URL}/api/convert-epub-markdown`, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || "Failed to convert EPUB to Markdown");
  }

  return data;
};
